
import AdminLayout from "@/components/layout/AdminLayout";
import { PolicyTypesContainer } from "@/components/admin/fields/policy-types/PolicyTypesContainer";
import { PolicyLinesContainer } from "@/components/admin/fields/policy-lines/PolicyLinesContainer";
import { CarriersContainer } from "@/components/admin/fields/carriers/CarriersContainer";
import { StatusesContainer } from "@/components/admin/fields/status/StatusesContainer";
import { LeadSourcesContainer } from "@/components/admin/fields/lead-sources/LeadSourcesContainer";
import { PolicyAcquisitionContainer } from "@/components/admin/fields/policy-acquisition/PolicyAcquisitionContainer";

const AdminFieldsPage = () => {
  return (
    <AdminLayout title="Add Fields">
      <div className="max-w-5xl mx-auto space-y-6">
        <div className="bg-white p-6 rounded-lg shadow">
          <PolicyAcquisitionContainer />
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <PolicyLinesContainer />
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <PolicyTypesContainer />
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <CarriersContainer />
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <LeadSourcesContainer />
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <StatusesContainer />
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminFieldsPage;
